module.exports = __webpack_public_path__ + "img/logo-ooca-norway.521a8e7d.png";